export default __webpack_public_path__ + "assets/images/5f8b9652f99d2e4dc4085a203c13c100.svg";